var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "EmdFormGroup",
    {
      attrs: {
        label: _vm.$t("recipients.create.email"),
        required: "",
        state: _vm.getState(_vm.$v.recipient.email),
        feedbacks: _vm.feedbacks(_vm.$v.recipient.email),
      },
    },
    [
      _vm.canEdit
        ? _c("EmdInput", {
            attrs: { type: "email", name: "email" },
            on: { input: () => _vm.$v.recipient.email.$touch() },
            model: {
              value: _vm.recipient.email,
              callback: function ($$v) {
                _vm.$set(_vm.recipient, "email", $$v)
              },
              expression: "recipient.email",
            },
          })
        : _c("span", [_vm._v(_vm._s(_vm.recipient.email))]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }